(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-collection-hero"] && !Shopify.designMode) return;
  try {
    
 (function () {
  function init(root) {
   (root || document).querySelectorAll('[data-ebh-desc]').forEach(function (box) {
    if (box.dataset.ebhReady) return;
    box.dataset.ebhReady = '1';
    var txt = box.querySelector('[data-ebh-text]');
    var btn = box.querySelector('[data-ebh-more]');
    if (!txt || !btn) return;
    var check = function () {
     if (box.classList.contains('is-open')) return;
     btn.hidden = txt.scrollHeight <= txt.clientHeight + 2;
    };
    btn.addEventListener('click', function () {
     box.classList.add('is-open');
     btn.hidden = true;
    });
    check();
    window.addEventListener('resize', check);
   });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
